{
  "version": 1,
  "asset_id": "7411ee6b-297e-4834-a5a3-85ca84ca052f",
  "project_id": "1820e758-46fa-46b0-bd5a-016534d0d263",
  "url": "/__l5e/assets-v1/7411ee6b-297e-4834-a5a3-85ca84ca052f/ind-hvac-home-services-1200.webp",
  "r2_key": "a/v1/1820e758-46fa-46b0-bd5a-016534d0d263/7411ee6b-297e-4834-a5a3-85ca84ca052f/ind-hvac-home-services-1200.webp",
  "original_filename": "ind-hvac-home-services-1200.webp",
  "size": 20136,
  "content_type": "image/webp",
  "created_at": "2026-07-25T02:26:05Z"
}
